import { EndpointService, EndpointOptions } from "../endpoint.service";
import { Injectable } from "@angular/core";
import { OrderState } from "../../state/order/order-state";
//import { saveAs } from 'file-saver';

/**
 * MyFoglio API sample code
 * http://guida.myfoglio.com/api
 * https://api.myfoglio.com/swagger/ui/index
 */
@Injectable()
export class MyFoglio {

  private rootUrl = '/s/myfoglio/';
  //https://api.myfoglio.com

  private options: EndpointOptions = {
    secure: true,
    mapper: data => data,
    resource: false,
  };

  constructor(
    private endpoint: EndpointService
  ) { }

  private getUrl(path): string {
    return this.rootUrl + path;
  }

  /*
  getInvoice(id: string): Promise<any | any[]> {
    return new Promise((resolve, reject) => {
      const url = this.getUrl('/invoice?id=' + id);
      this.endpoint.getOne(url, this.options).subscribe(result => {
        console.log(result);
        resolve(result);
      }, error => reject(error));
    });
  }
  */

  getPdfInvoice(id: string): Promise<any | any[]> {
    return new Promise((resolve, reject) => {
      const url = this.getUrl(id);
      this.options.resource = true;
      this.endpoint.getOne(url, this.options).subscribe(result => {
        resolve(result.data);
      }, error => reject(error));
    });
  }

  createInvoice(order: OrderState): Promise<any | any[]> {
    return new Promise((resolve, reject) => {
      const url = this.getUrl("");
      const body = {
        "AccountingDate": new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''),
        "Buyer": {
          "ContactType": "Contact",
          "CompanyName": order.customer.getLegalName(),
          "VatNumber": order.customer.address.vat,
          "FiscalCode": order.customer.address.fiscalCode,
          "LegalAddress": {
            "Country": order.customer.address.country,
            "State": order.customer.address.province,
            "City": order.customer.address.city,
            "Street": order.customer.address.address,
            "ZipCode": order.customer.address.zipCode
          },
          "LegalTelephoneAndEmail": {
            "Phone": order.customer.phoneNr,
            "Email": order.customer.email
          },
          "WorkAddress": {
            "Country": order.customer.address.country
          }
        },
        "Items": [
          {
            "Code": order.orderId,
            "Description": order.estimate.issues[0].code,
            "Units": "1",
            "Quantity": 1.0,
            "DiscountRate": 0.0,
            "Amount": (order.estimate.totalAmountVat / 100.00),
            "VatRateCode": "IVA22",
            "InverseCalculation": true,
            "IsExpense": false,
            "Taxable": true
          }
        ],
        "DocumentFormat": "IT_FPR",
        "FatturaPA": {
          "DatiTrasmissione": {
            "CodiceDestinatario": order.customer.address.sdiCode,
            "PECDestinatario": order.customer.address.pec
          },
          "DatiGenerali": {
            "TipoDocumento": "TD01"
          }
        },
        "PaymentsData": {
          "Paid": true,
          "Instalments": [
            {
              "PaymentTerms": "MP08", //this code means payment method Credit Card
              "WasPaid": true
            }
          ]
        }
      };
      this.endpoint.post(url, body, this.options).subscribe(result => {
        console.log(result);
        resolve(result);
      }, error => reject(error));
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/service/myfoglio.ts